import { BuildbotMinimalWebsite } from '@bm-js/atlascloud-shared'

export const isEditor = () => {
  if (typeof window === 'undefined') return false
  return !!window.atlasCloudIsEditorContext
}

export const getGoogleMapsLink = (
  contactInfo: BuildbotMinimalWebsite['contactInfo']
): string | null => {
  const linkBase = 'https://www.google.com/maps/dir/?api=1&destination='
  const { adress, postalCode, postalArea } = contactInfo

  if (!adress || !postalArea || !postalCode) return null

  const comma = '%2C'
  const space = '%20'
  const parsedAddress = adress.split('\n').join(comma)
  return `${linkBase}${parsedAddress}${comma}${space}${postalCode}${space}${postalArea}`
}

const marginOptionsRaw = [
  0, 0.5, 1, 2, 3, 4, 5, 6, 8, 10, 12, 14, 16, 20, 24, 28, 32,
]

export const marginOptions = marginOptionsRaw.map((value) => ({
  value: `${value}rem`,
  name: `${value * 16}px`,
  tw: `${value * 4}`,
}))

export const marginBottoms = marginOptions.reduce((acc, opt) => {
  acc[opt.value] = `mb-${opt.tw}`
  return acc
}, {} as Record<string, string>)

export const marginTops = marginOptions.reduce((acc, opt) => {
  acc[opt.value] = `mt-${opt.tw}`
  return acc
}, {} as Record<string, string>)

export const roundeds = {
  '': '',
  'rounded-none': 'rounded-none',
  'rounded-md': 'rounded-md',
  'rounded-xl': 'rounded-xl',
}

export const shadows = {
  '': '',
  'shadow-none': 'shadow-none',
  'shadow-md': 'shadow-md',
  'shadow-xl': 'shadow-xl',
}
